import styled from 'styled-components';

const DisplayLabel = styled.span`
  display: block;
  color: #999;
  font-size: 14px;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 0.075em;
`;

export default DisplayLabel;



// WEBPACK FOOTER //
// ./src/components/text/DisplayLabel/index.js